<h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">
  {{ 'Dine oppgaver'|translate }}
  <button mat-icon-button type="button" (click)="lukk()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<div class="panel-skrollkontainer" [style.max-height.px]="maksPopupHoeyde() - 40"><!-- -40 for å ta høyde for høyden til overliggende h2 -->
  @for (oppgave of brukersOppgaverBegrensetTilMaksAntall(); track oppgave.id; ) {
    <oppgave-listevisning-kompakt [oppgave]="oppgave" visForelder="true" (click)="gaaTilOppgave(oppgave)"/>
  }

  @if (brukersOppgaver().length > maksAntallOppgaverAaVise()) {
    <div class="vis-alle">
      {{ 'Du har totalt {antall} oppgaver'|translate:{antall: brukersOppgaver().length} }},
      <a (click)="gaaTilListMineIkkeUtfoerteOppgaver()">{{ 'gå til oppgavesiden for å se alle'|translate }}</a>
    </div>
  }

  @if (brukersOppgaver().length == 0) {
    <div class="ingen-oppgaver" data-testid="ingenoppgaver">
      {{ 'Du har utført alle oppgavene dine'|translate }}
      <mat-icon>celebration</mat-icon>
    </div>
  }

  @if (harSkrivetilgang()) {
    <h2 class="panel-gruppe-tittel andres" data-testid="dashboardstatus-radtittel">{{ 'Andres forfalte oppgaver'|translate }}</h2>

    @if (antallOppgaverTilknyttetAndre().length === 0) {
      <div class="ingen-oppgaver">
        {{ 'Alle andre har utført sine oppgaver'|translate }}
        <mat-icon>celebration</mat-icon>
      </div>
    } @else {
      @for (antallOppgaver of antallOppgaverTilknyttetAndre(); track $index) {
        <div class="andres_oppgaver" data-testid="andres-oppgaver">
          <avatar [bruker]="antallOppgaver.bruker"></avatar>
          @if (antallOppgaver.bruker != null) {
            <a class="navn" (click)="gaaTilListBrukersForfalteOppgaver(antallOppgaver.bruker)" data-testid="bruker">{{ antallOppgaver.bruker.navnEllerEpost }}</a>
          } @else {
            <span class="navn" data-testid="bruker">{{ 'Ingen ansvarlig'|translate }}</span>
          }
          <div class="antall">
            @if (antallOppgaver.bruker != null) {
              <a (click)="gaaTilListBrukersForfalteOppgaver(antallOppgaver.bruker)" data-testid="antalloppgaver">
                {{ '{antall} forfalte oppgaver'|translate:{antall: antallOppgaver.antallForfalte} }}
              </a>
            } @else {
              <span data-testid="antalloppgaver">
                {{ '{antall} forfalte oppgaver'|translate:{antall: antallOppgaver.antallForfalte} }}
              </span>
            }
          </div>
        </div>
      }
    }
  }
</div>
